import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as svc from './visitas-service';
import { visitasKeys } from './keys';
import type { CreateVisitaDto, QueryVisitasDto } from './visitas-service';

export function useVisitasList(params: QueryVisitasDto) {
  return useQuery({
    queryKey: visitasKeys.list(params as unknown as Record<string, unknown>),
    queryFn: () => svc.getVisitas(params),
    staleTime: 30_000,
  });
}

export function useVisitasStats(params: Omit<QueryVisitasDto, 'offset' | 'limit'>) {
  return useQuery({
    queryKey: visitasKeys.stats(params as unknown as Record<string, unknown>),
    queryFn: () => svc.getVisitasStats(params),
    staleTime: 30_000,
  });
}

export function useCreateVisita() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (dto: CreateVisitaDto) => svc.createVisita(dto),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: visitasKeys.lists() });
    },
  });
}
